(function () {
  const THRESHOLD_CENTS = 75 * 100;

  function formatEUR(cents) {
    const euros = cents / 100;
    return euros.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '€';
  }

  function ensureStyles() {
    if (document.getElementById('gl-free-shipping-style')) return;
    const style = document.createElement('style');
    style.id = 'gl-free-shipping-style';
    style.textContent = `
      .gl-free-ship{
        margin: 14px 0 10px;
        padding: 12px 12px;
        border: 1px solid rgba(10,35,66,.14);
        border-radius: 12px;
        background: rgba(255,255,255,.35);
      }
      .gl-free-ship__text{
        font-size: 13px;
        line-height: 1.35;
        margin: 0 0 8px 0;
        color: #0A2342;
      }
      .gl-free-ship__bar{
        height: 5px;
        background: rgba(10,35,66,.10);
        border-radius: 999px;
        overflow: hidden;
      }
      .gl-free-ship__fill{
        height: 100%;
        width: 0%;
        background: #0A2342;
        transition: width .25s ease;
        border-radius: 999px;
      }
    `;
    document.head.appendChild(style);
  }

  function findDrawer() {
    return document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.cart-drawer');
  }

  function findCheckoutAnchor(drawer) {
    if (!drawer) return null;

    // Bouton/zone de checkout la plus fréquente
    return drawer.querySelector('form[action^="/checkout"]') ||
      drawer.querySelector('button[name="checkout"]') ||
      drawer.querySelector('a[href^="/checkout"]') ||
      drawer.querySelector('a[href*="/checkout"]') ||
      null;
  }

  function ensureBar() {
    ensureStyles();

    const drawer = findDrawer();
    if (!drawer) return null;

    const anchor = findCheckoutAnchor(drawer);
    if (!anchor) return null;

    // Si la barre existe déjà, on ne recrée pas
    let bar = drawer.querySelector('#gl-free-ship');
    if (bar) return bar;

    bar = document.createElement('div');
    bar.id = 'gl-free-ship';
    bar.className = 'gl-free-ship';
    bar.innerHTML = `
      <p class="gl-free-ship__text" data-gl-free-ship-text></p>
      <div class="gl-free-ship__bar"><div class="gl-free-ship__fill" data-gl-free-ship-fill></div></div>
    `;

    // On insère juste avant le checkout (meilleur endroit conversion)
    anchor.parentNode.insertBefore(bar, anchor);
    return bar;
  }

  function updateBarFromCart(cart) {
    const bar = ensureBar();
    if (!bar || !cart) return;

    const textEl = bar.querySelector('[data-gl-free-ship-text]');
    const fillEl = bar.querySelector('[data-gl-free-ship-fill]');

    const total = Number(cart.total_price || 0);
    const remaining = THRESHOLD_CENTS - total;

    if (total >= THRESHOLD_CENTS) {
      textEl.textContent = 'Livraison offerte activée ✨';
      fillEl.style.width = '100%';
    } else {
      textEl.textContent = `Plus que ${formatEUR(remaining)} pour bénéficier de la livraison offerte 🎁`;
      const pct = Math.max(0, Math.min(100, (total / THRESHOLD_CENTS) * 100));
      fillEl.style.width = pct.toFixed(0) + '%';
    }
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  }

  // 1) Mise à jour quand Atelier signale "cart:update"
  document.addEventListener('cart:update', (e) => {
    if (e.detail && e.detail.resource) {
      updateBarFromCart(e.detail.resource);
    }
  });

  // 2) Au chargement + quand le drawer apparaît (observer)
  const observer = new MutationObserver(async () => {
    const bar = ensureBar();
    if (bar) {
      const cart = await fetchCart();
      if (cart) updateBarFromCart(cart);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // 3) Première mise à jour (si le drawer est déjà présent)
  (async () => {
    const cart = await fetchCart();
    if (cart) updateBarFromCart(cart);
  })();
})();